'use client';

import { pageRouteTitleMap } from '@/utils/routes';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import useRedirect from '@/hooks/useRedirect';

const PREVIOUS_PATH_QUERY_PARAM_NAME = 'previousPath';

const useRouterNavigation = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { dispatchRedirect } = useRedirect();

  const pushPath = useCallback(
    (destination: string) => {
      const [newPath, search] = destination.split('?');

      const currentURLWithParams =
        pathname + (typeof window !== 'undefined' && window.location.search ? window.location.search : '');

      const params = new URLSearchParams(search);
      params.set(PREVIOUS_PATH_QUERY_PARAM_NAME, encodeURIComponent(currentURLWithParams));

      const queryString = params.toString();
      const finalUrl = queryString ? `${newPath}?${queryString}` : newPath;
      dispatchRedirect(finalUrl);
    },
    [pathname, dispatchRedirect]
  );

  const getPreviousPath = (): string | undefined => {
    const previousPath = searchParams.get(PREVIOUS_PATH_QUERY_PARAM_NAME);
    const decodedPath = previousPath ? decodeURIComponent(previousPath) : undefined;
    return decodedPath ? decodedPath : undefined;
  };

  const previousPath = getPreviousPath();
  const previousPageTitle = previousPath && pageRouteTitleMap[previousPath];

  return { pushPath, previousPath, previousPageTitle };
};

export default useRouterNavigation;
